import { CONTAINER_TYPES } from '@src/quince-site-common/src/organisms/pageBuilder'
import { IContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder/pageBuilder.domains'

import { ProductSectionType } from '../../types/productPage.types'
import {
  DESKTOP_DISCLAIMER,
  DESKTOP_FAQ,
  DESKTOP_FBT,
  DESKTOP_INFLUENCER,
  DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
  DESKTOP_PRODUCT_REVIEWS,
  DESKTOP_SIMILAR_PRODUCTS,
  DESKTOP_TRANSPARENT_PRICING,
  DESKTOP_YOU_MAY_ALSO_LIKE,
} from '../common'
import {
  MOBILE_REVIEW_HIGHLIGHTS,
  MOBILE_PRODUCT_DETAILS_AND_CARE,
  MOBILE_BRAND_COMPARISON,
  MOBILE_PAIR_WITH,
  MOBILE_SIMILAR_PRODUCTS,
  MOBILE_TRANSPARENT_PRICING,
  MOBILE_INFLUENCER,
  MOBILE_INFORMATION_BOXES,
  MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
  MOBILE_PRODUCT_REVIEWS,
  MOBILE_YOU_MAY_ALSO_LIKE,
  MOBILE_DISCLAIMER,
} from '../common/mobile'

export const bundleDesktopConfig: IContainerConfig = {
  id: 'DESKTOP_BUNDLE_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    {
      id: 'BUNDLE_PRODUCT_IMAGES_AND_PURCHASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.BUNDLE_PRODUCT_IMAGES_AND_PURCHASE,
      },
    },
    DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
    DESKTOP_SIMILAR_PRODUCTS,
    DESKTOP_PRODUCT_REVIEWS,
    DESKTOP_TRANSPARENT_PRICING,
    DESKTOP_INFLUENCER,
    DESKTOP_FBT,
    DESKTOP_FAQ,
    DESKTOP_YOU_MAY_ALSO_LIKE,
    DESKTOP_DISCLAIMER,
  ],
}

export const bundleMobileConfig: IContainerConfig = {
  id: 'MOBILE_BUNDLE_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    {
      id: 'MOBILE_BUNDLE_PRODUCT_IMAGES_AND_PURCHASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.BUNDLE_PRODUCT_IMAGES_AND_PURCHASE,
      },
    },
    MOBILE_REVIEW_HIGHLIGHTS,
    MOBILE_PRODUCT_DETAILS_AND_CARE,
    MOBILE_BRAND_COMPARISON,
    MOBILE_PAIR_WITH,
    MOBILE_SIMILAR_PRODUCTS,
    MOBILE_TRANSPARENT_PRICING,
    MOBILE_INFLUENCER,
    MOBILE_INFORMATION_BOXES,
    MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
    MOBILE_PRODUCT_REVIEWS,
    MOBILE_YOU_MAY_ALSO_LIKE,
    MOBILE_DISCLAIMER,
  ],
}
